export function gql(strings, ...args) {
  let str = "";
  strings.forEach((string, i) => {
    str += string + (args[i] || "");
  });
  return str;
}
export const PagePartsFragmentDoc = gql`
    fragment PageParts on Page {
  __typename
  ... on PageHome {
    title
    seo {
      __typename
      title
      description
      canonicalPath
      socialImage
      noIndex
    }
    hero {
      __typename
      title
      highlight
      subtitle
      ctaLabel
      ctaHref
      imageSrc
      imageAlt
    }
    intro {
      __typename
      label
      title
      highlights
      description
    }
    benefits {
      __typename
      intro
      items {
        __typename
        icon
        title
        text
      }
      outro
    }
    pricing {
      __typename
      eyebrow
      title
      description
      currencySymbol
      plans {
        __typename
        label
        name
        description
        price
        duration
        ctaLabel
        ctaHref
        featured
        badge
        features
      }
    }
    tiles {
      __typename
      title
      description
      href
      linkLabel
      imageSrc
      imageAlt
    }
    reviews {
      __typename
      eyebrow
      title
      description
      rating
      ratingSummary
      items {
        __typename
        text
        author
      }
      disclaimer
      ctaLabel
      ctaHref
    }
  }
  ... on PageBooking {
    title
    seo {
      __typename
      title
      description
      canonicalPath
      socialImage
      noIndex
    }
    eyebrow
    heading
    description
    widgetUrl
    ctaLabel
    ctaHref
  }
  ... on PageAboutUs {
    title
    seo {
      __typename
      title
      description
      canonicalPath
      socialImage
      noIndex
    }
    hero {
      __typename
      eyebrow
      title
      intro
    }
    story {
      __typename
      eyebrow
      title
      paragraphs
    }
    contact {
      __typename
      title
      phoneNumber
      phoneLabel
      mapsUrl
      mapEmbedUrl
      mapsLabel
    }
  }
  ... on PageEvents {
    title
    seo {
      __typename
      title
      description
      canonicalPath
      socialImage
      noIndex
    }
    eyebrow
    heading
    description
    eventType
    events {
      __typename
      month
      dates
      year
      title
      venue
      location
    }
  }
  ... on PageMassageServices {
    title
    seo {
      __typename
      title
      description
      canonicalPath
      socialImage
      noIndex
    }
    hero {
      __typename
      eyebrow
      title
      titleHighlight
      intro
      ctaLabel
      ctaHref
      imageSrc
      imageAlt
      imageNote
    }
    method {
      __typename
      eyebrow
      title
      paragraphs
      mantra
      focusTitle
      focusAreas
    }
    options {
      __typename
      eyebrow
      title
      description
      items {
        __typename
        duration
        name
        description
        steps {
          __typename
          duration
          label
        }
        ctaLabel
        ctaHref
        featured
      }
    }
    story {
      __typename
      eyebrow
      title
      text
    }
    benefitCards {
      __typename
      icon
      title
      text
    }
    spineGuide {
      __typename
      eyebrow
      title
      description
      imageSrc
      imageAlt
      massageGoal
      disclaimer
      regions {
        __typename
        name
        vertebrae {
          __typename
          level
          areas
          symptoms
        }
      }
    }
    feature {
      __typename
      imageSrc
      imageAlt
      eyebrow
      title
      text
      ctaLabel
      ctaHref
    }
  }
  ... on PageMatrixDrops {
    title
    seo {
      __typename
      title
      description
      canonicalPath
      socialImage
      noIndex
    }
    hero {
      __typename
      eyebrow
      title
      titleHighlight
      intro
      ctaLabel
      ctaHref
      secondaryLabel
      imageSrc
      imageAlt
      badge
    }
    idea {
      __typename
      eyebrow
      title
      paragraphs
    }
    library {
      __typename
      imageSrc
      imageAlt
      eyebrow
      title
      text
      linkLabel
    }
    coldFusion {
      __typename
      eyebrow
      title
      intro
      callouts {
        __typename
        title
        text
        images {
          __typename
          imageSrc
          imageAlt
        }
      }
    }
    examples {
      __typename
      eyebrow
      title
      intro
      tables {
        __typename
        title
        codeHeading
        rows {
          __typename
          name
          code
        }
      }
      note
    }
    complex {
      __typename
      eyebrow
      title
      items {
        __typename
        name
        code
        detail
      }
      linkLabel
    }
    computer {
      __typename
      eyebrow
      title
      text
      primaryLabel
      secondaryLabel
      topicsTitle
      topics
    }
    life {
      __typename
      title
      text
      linkLabel
    }
    guidance {
      __typename
      eyebrow
      title
      steps
    }
    disclaimer {
      __typename
      title
      text
    }
  }
  ... on PageMatrixDropsProtocol {
    title
    seo {
      __typename
      title
      description
      canonicalPath
      socialImage
      noIndex
    }
    hero {
      __typename
      eyebrow
      title
      titleHighlight
      intro
      ctaLabel
      ctaHref
      imageSrc
      imageAlt
    }
    pillarsSection {
      __typename
      eyebrow
      title
      intro
      pillars {
        __typename
        title
        text
        images {
          __typename
          imageSrc
          imageAlt
        }
      }
      note
    }
    kma {
      __typename
      eyebrow
      number
      title
      text
      linkLabel
      linkHref
    }
    geopathic {
      __typename
      eyebrow
      number
      title
      subsections {
        __typename
        title
        paragraphs
        imageSrc
        imageAlt
      }
    }
    diet {
      __typename
      eyebrow
      number
      title
      avoid {
        __typename
        title
        foods
        imageSrc
        imageAlt
      }
      recommended {
        __typename
        title
        foods
        imageSrc
        imageAlt
      }
      note
    }
  }
}
    `;
export const NavigationPartsFragmentDoc = gql`
    fragment NavigationParts on Navigation {
  __typename
  title
  links {
    __typename
    name
    link
  }
  buttons {
    __typename
    label
    url
    style
  }
}
    `;
export const GalleryPartsFragmentDoc = gql`
    fragment GalleryParts on Gallery {
  __typename
  eyebrow
  title
  description
  items {
    __typename
    imageSrc
    alt
  }
}
    `;
export const PageDocument = gql`
    query page($relativePath: String!) {
  page(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PageParts
  }
}
    ${PagePartsFragmentDoc}`;
export const PageConnectionDocument = gql`
    query pageConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PageFilter) {
  pageConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PageParts
      }
    }
  }
}
    ${PagePartsFragmentDoc}`;
export const NavigationDocument = gql`
    query navigation($relativePath: String!) {
  navigation(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...NavigationParts
  }
}
    ${NavigationPartsFragmentDoc}`;
export const NavigationConnectionDocument = gql`
    query navigationConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: NavigationFilter) {
  navigationConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...NavigationParts
      }
    }
  }
}
    ${NavigationPartsFragmentDoc}`;
export const GalleryDocument = gql`
    query gallery($relativePath: String!) {
  gallery(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...GalleryParts
  }
}
    ${GalleryPartsFragmentDoc}`;
export const GalleryConnectionDocument = gql`
    query galleryConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: GalleryFilter) {
  galleryConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...GalleryParts
      }
    }
  }
}
    ${GalleryPartsFragmentDoc}`;
export function getSdk(requester) {
  return {
    page(variables, options) {
      return requester(PageDocument, variables, options);
    },
    pageConnection(variables, options) {
      return requester(PageConnectionDocument, variables, options);
    },
    navigation(variables, options) {
      return requester(NavigationDocument, variables, options);
    },
    navigationConnection(variables, options) {
      return requester(NavigationConnectionDocument, variables, options);
    },
    gallery(variables, options) {
      return requester(GalleryDocument, variables, options);
    },
    galleryConnection(variables, options) {
      return requester(GalleryConnectionDocument, variables, options);
    }
  };
}
import { createClient } from "tinacms/dist/client";
const generateRequester = (client) => {
  const requester = async (doc, vars, options) => {
    let url = client.apiUrl;
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf("/");
      url = client.apiUrl.substring(0, index + 1) + options.branch;
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url
    }, options);
    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} };
  };
  return requester;
};
export const ExperimentalGetTinaClient = () => getSdk(
  generateRequester(
    createClient({
      url: "http://localhost:4001/graphql",
      queries
    })
  )
);
export const queries = (client) => {
  const requester = generateRequester(client);
  return getSdk(requester);
};
